var _jsxFileName = "/codebuild/output/src454737571/src/bitbucket.org/newyuinc/adc-polaris-web/src/components/LandingPage/index.tsx";
import React from 'react';
import { VStack } from '@adc/parallax-component-library';
import { Button } from 'Components/utility';
import i18n from 'Utilities/i18n';
import mediator from 'Utilities/mediator';
const LandingScreen = () => {
  const handleClickSignIn = () => {
    mediator.publish('router:navigate', '/login');
  };
  const handleClickCreateAccount = () => {
    mediator.publish('router:navigate', '/create-account');
  };
  return /*#__PURE__*/React.createElement(VStack, {
    padding: "$4",
    justifyContent: "center",
    backgroundColor: "$surface.background",
    gap: "$4",
    style: {
      height: '100vh'
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 20,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Button, {
    onPress: handleClickSignIn,
    testID: "LandingPage.signIn",
    "aria-label": "",
    label: i18n.t('LandingPage.microcopy.landingPageButtons.signIn'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Button, {
    onPress: handleClickCreateAccount,
    testID: "LandingPage.createAccount",
    "aria-label": "",
    label: i18n.t('LandingPage.microcopy.landingPageButtons.createAccount'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 33,
      columnNumber: 7
    }
  }));
};
export default LandingScreen;